/**
 *
 * Asynchronously loads the component for UserTrainingPage
 *
 */

import { lazyLoad } from 'utils/loadable';

export const ServiceRequestAuditTrailHistoryPage = lazyLoad(
  () => import('./index'),
  module => module.ServiceRequestAuditTrailHistoryPage,
);
